import React from 'react';

import { formatMoney, toMoney } from '@betterment/js-runtime';
import { Text } from '@betterment/samba-react';

import { ModalSectionRow } from '../../../../Shared/components-v2/modal-section/ModalSectionRow';
import { PurposeSettingsQuery } from '../graphql/purposeSettings.generated';

type Props = {
  target: Extract<PurposeSettingsQuery['purpose']['target'], { __typename: 'TargetAmountAndDate' }>;
};
type RowTuple = [string, string | number];

export const TargetAmountAndDate: React.FC<React.PropsWithChildren<Props>> = ({ target }) => {
  const targetAmount = target.amount ? formatMoney(toMoney(target.amount.cents)) : 'Not set';

  const targetDate = target.date?.toLocaleDateString('en-US', { month: 'long', year: 'numeric' }) || 'Not set';

  const majorPurchaseTuples: RowTuple[] = [
    ['Target Amount', targetAmount],
    ['Target Date', targetDate],
  ];

  return (
    <>
      {majorPurchaseTuples.map(tuple => (
        <ModalSectionRow key={tuple[0]}>
          <ModalSectionRow.LeadingContent>
            <Text>{tuple[0]}</Text>
          </ModalSectionRow.LeadingContent>
          <ModalSectionRow.TrailingContent>
            <Text>{tuple[1]}</Text>
          </ModalSectionRow.TrailingContent>
        </ModalSectionRow>
      ))}
    </>
  );
};
